import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Step } from "../../models/step";
import { stepMap } from "./config/step";
import { CreazionePraticaStoreService } from "../../services/creazione-pratica-store.service";
import { InsertionHostDirective } from "../../../../../common/directives/insertion-host.directive";
import { DialogRef } from "../../../../../core/components/dialog/dialog-ref";
import { DialogConfig } from "../../../../../core/components/dialog/dialog-config";
import { DocumentManagementService } from "../../../../../document-management/services/document-management.service";
import { OperationsService } from "../../../../../core/services/operations.service";
import { ServicePathsSettings as sps } from "../../../../../core/configuration/service-paths-settings";
import { filter, skipWhile, take, takeUntil, tap } from "rxjs/operators";
import { CreazionePraticaService } from "../../services/creazione-pratica.service";
import { FascicoloTemp } from "../../models/fascicolo-temp";
import { Route, Router } from "@angular/router";
@Component({
  selector: "app-creazione-pratica-stepper",
  templateUrl: "./creazione-pratica-stepper.component.html",
  styleUrls: ["./creazione-pratica-stepper.component.css"],
})
export class CreazionePraticaStepperComponent implements OnInit, OnDestroy {
  @ViewChild(InsertionHostDirective) step: InsertionHostDirective;
  @ViewChild("divStepper") divStepper: ElementRef;
  stepList: Step[];
  idElaborazione: string;
  idPratica: string;
  tipoPratica: string;
  stepMap = stepMap;
  currentStepNumber = 1;
  componentRef: ComponentRef<any>;
  showCompleta: boolean = false;
  showElimina: boolean = false;
  showSalvaAndEsci : boolean = true;
  fascicoloTemp: FascicoloTemp = {
    fascicoloTemp: { id: null, step: null, valore: null },
  };
  //maxStep = 0;

  private componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig,
    private documentManagementService: DocumentManagementService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private creazionePraticaStore: CreazionePraticaStoreService,
    private operationsService: OperationsService,
    private creazionePraticaService: CreazionePraticaService,
    private router: Router
  ) {
    this.creazionePraticaStore.stepList$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((stepList) => (this.stepList = stepList));
    this.creazionePraticaStore.checkValidity$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((validity) => (this.showCompleta = validity));
    this.creazionePraticaStore.fascicoloTempID$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((id) => {
        this.fascicoloTemp.fascicoloTemp.id = id;
        this.showElimina = id != null;
      });
    this.creazionePraticaStore.currentStep$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((step) => {
        this.fascicoloTemp.fascicoloTemp.step = step;
      });
    this.creazionePraticaStore.fascicoloTemp$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((val) => (this.fascicoloTemp.fascicoloTemp.valore = val));
    /*this.creazionePraticaStore.fascicoloTemp$.subscribe(fascicolo => {
      this.showCompleta = this.creazionePraticaStore.isValid(fascicolo);
    })*/
  }

  ngOnInit() {
    this.creazionePraticaStore.fromWizard = true;
    if (this.dialogConfig.data) {
      this.idElaborazione = this.dialogConfig.data.idElaborazione;
      this.idPratica = this.dialogConfig.data.idPratica;
      this.tipoPratica = this.dialogConfig.data.tipoPratica;
    }

    if (this.idElaborazione) {
      if (this.idElaborazione === "new") {
        this.creazionePraticaStore
          .setElaborazione(this.idElaborazione);
        this.changeStep(this.currentStepNumber,false, null)
        this.showSalvaAndEsci = false;
        this.showElimina = false;
      } else {
        this.creazionePraticaStore
          .setElaborazione(this.idElaborazione)
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe((res) => {
            if (res.fascicoloTemp && res.fascicoloTemp.step) {
              this.changeStep(res.fascicoloTemp.step.numeroStep, true);
            }
          });

        this.documentManagementService
          .getElaborationEntities(this.idElaborazione)
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe((el) => this.creazionePraticaStore.setEntities(el));

        this.creazionePraticaStore.elaborationLoaded$
          .pipe(skipWhile((res) => !res))
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe(() => this.changeStep(this.currentStepNumber, true));
      }
    }

    if (this.idPratica) {
      this.operationsService
        .readPratica(
          `${sps.OPERATIONS_PATH}${sps.GESTIONE_PRATICHE_PATH}/${this.tipoPratica}/prat`,
          this.idPratica
        )
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe((res) => {
          this.creazionePraticaStore.updatePratica(
            res.pratica,
            res.pratica.tipoPratica,
            null
          );
          //this.creazionePraticaStore.setTipoPratica(res.pratica.tipoPratica);

          this.operationsService
            .readClassificazione(this.idPratica)
            .subscribe((classificazioni) => {
              this.creazionePraticaStore.setClassificazioni(
                classificazioni.pratica.classificazioni
              );
              this.changeStep(2);
            });
        });
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
  }

  async changeStep(
    numeroStep: number,
    init: boolean = false,
    stepCheck: Step = null
  ) {
    console.log(numeroStep,init,stepCheck);
    //(numeroStep > this.maxStep)?this.maxStep = numeroStep:'';
    if (stepCheck === null || !this.isStepItemDisabled(stepCheck)) {
      this.currentStepNumber = numeroStep;
      if (!init && this.idElaborazione) {
        await this.creazionePraticaStore.save();
      }
      const step = this.stepMap.find((el) => el.numeroStep === numeroStep);
      if (step && step.component) {
        this.creazionePraticaStore.setCurrentStep(this.currentStepNumber);
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(step.component);

        const viewContainerRef = this.step?.viewContainerRef;
        if (viewContainerRef) {
          viewContainerRef.clear();
        }

        // FIXME: POSSIBILE MEMORY LEAK DOVUTO ALLE SUBSCRIBES DEL COMPONENTE ??
        //  - Trovare il componente nella memoria quando e' renderizzato
        //  - Dopo il destroy controllare se viene eliminato
        if (this.componentRef) {
          this.componentRef.destroy();
        }

        this.componentRef = viewContainerRef?.createComponent(componentFactory);

        if (this.componentRef && !!this.componentRef.instance.changeStep) {
          this.componentRef.instance.changeStep
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => this.changeStep(this.currentStepNumber + 1));
        }
      }
    }
  }

  get buttonLabel() {
    return this.currentStep && this.currentStep.buttonLabel
      ? this.currentStep.buttonLabel
      : "Prosegui";
  }

  get currentStep() {
    return this.stepMap.find((el) => el.numeroStep === this.currentStepNumber);
  }

  async salva() {
    await this.changeStep(this.currentStepNumber + 1);
  }

  //Salva ed esci
  async exit() {
    this.creazionePraticaStore.fromWizard = false;
    this.creazionePraticaStore.setSaveExitEvent(true);
    await this.salva();
    this.creazionePraticaStore.setSaveExitEvent(false);
    this.dialogRef.close({
      fascicoloTempDeleted: false,
      fascicoloTemp: this.fascicoloTemp,
    });
  }

  completa() {
    this.creazionePraticaStore.fromWizard = false;
    this.creazionePraticaStore.completa();
    this.creazionePraticaStore.fascicoloCreato$
      .pipe(take(1))
      .subscribe((fascicolo) => {
        console.log(fascicolo);
        if (fascicolo !== null) {
          this.dialogRef.close({
            fascicoloTempDeleted: true,
            fascicoloCreato: fascicolo,
          });
        } else {
          this.dialogRef.close({
            fascicoloTempDeleted: false,
            fascicoloTemp: this.fascicoloTemp,
          });
        }
      });
  }

  deleteFascicoloTemp() {
    this.creazionePraticaStore.deleteFascicoloTemp().subscribe((it) => {
      this.creazionePraticaStore.fromWizard = false;
      console.log("[deleteFascicoloTemp]", it);
      this.dialogRef.close({ fascicoloTempDeleted: true });
    });
  }

  isStepItemDisabled(step: Step): boolean {
    let itemDisabled: boolean = false;
    if (step && step.numeroStep > 1) {
      if (step.numeroStep == 2) {
        //STEP 2 SI ABILITA QUANDO SI SELEZIONA UNA PRATICA
        itemDisabled = !this.creazionePraticaStore.getTipoPratica();
      } else if (step.numeroStep > 2) {
        // STEP SUCCESSIVI AL 2 SI ABILITANO QUANDO SIA PRATICA CHE FASCICOLO SONO STATI DEFINITI
        itemDisabled =
          !this.creazionePraticaStore.getTipoPratica() ||
          !this.creazionePraticaStore.getTipoFascicolo();
      }
    }
    return itemDisabled;
  }

  isStepItemCompleted(step: Step): boolean {
    // return step.numeroStep <= this.currentStep.numeroStep || step.numeroStep <= this.maxStep-1 ;
    if (step.numeroStep > 5 || step.numeroStep == 4) {
      return this.creazionePraticaStore.hasStepData(step.numeroStep);
    } else {
      return !this.isStepItemError(step);
    }
  }

  isStepItemError(step: Step) {
    return !this.creazionePraticaStore.isValidStep(step.numeroStep);
  }

  isStepItemActive(step: Step): boolean {
    return step.numeroStep == this.currentStep.numeroStep;
  }
}
